import { useMemo, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Link, NavLink, useLocation } from "react-router-dom";
import classNames from "classnames";
import logo from "../../assets/imgs/logo.svg";
import logoLight from "../../assets/imgs/logo-light.svg";
import { menu } from "../../utils/consts";

export default function Header({ style = "primary" }) {
    const location = useLocation();

    const isMobile = useMediaQuery({
        query: "(max-width: 1024px)",
    });

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const currentLogo = isMobile || style === "primary" ? logo : logoLight;

    const mobileExtraLinks = useMemo(
        () => [
            {
                title: "CREATE ACCOUNT",
                href: "https://apps.pixad.com.tr/auth/sign-up",
            },
            {
                title: "LOGIN",
                href: "https://apps.pixad.com.tr/",
            },
        ],
        []
    );

    const closeMenu = () => setIsMenuOpen(false);
    const toggleMenu = () => setIsMenuOpen((prev) => !prev);

    const renderMenuItem = (item, isExternal = false) => {
        if (isExternal) {
            return (
                <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={closeMenu}
                >
                    {item.title}
                </a>
            );
        }

        return (
            <NavLink to={item.path} onClick={closeMenu}>
                {item.title}
            </NavLink>
        );
    };

    return (
        <header
            className={classNames("header", {
                primary: isMobile,
                [style]: !isMobile,
            })}
        >
            <div>
                <button className="nav-bar-btn" onClick={toggleMenu}>
                    <span
                        className={classNames({
                            open: isMobile && isMenuOpen,
                        })}
                    ></span>
                </button>

                <Link to="/" className="header__logo" onClick={closeMenu}>
                    <img src={currentLogo} alt="Pixad" />
                </Link>

                <nav
                    className={classNames("nav__menu", {
                        show: isMobile && isMenuOpen,
                    })}
                >
                    <ul>
                        {menu.map((item) => (
                            <li key={item.path}>{renderMenuItem(item)}</li>
                        ))}

                        {isMobile &&
                            mobileExtraLinks.map((item) => (
                                <li key={item.href}>
                                    {renderMenuItem(item, true)}
                                </li>
                            ))}
                    </ul>
                </nav>
            </div>

            <div className="sub__nav">
                <div className="sub__nav-actions">
                    <a
                        className={classNames(
                            "action-button-fill pixad",
                            location.pathname === "/publishers"
                                ? "primary"
                                : style
                        )}
                        href="https://apps.pixad.com.tr/auth/sign-up"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        CREATE ACCOUNT
                    </a>

                    <a
                        className={classNames(
                            "action-button-normal",
                            style
                        )}
                        href="https://apps.pixad.com.tr/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        LOGIN
                    </a>
                </div>
            </div>
        </header>
    );
}